export default theme => ({
  generalTitle: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4)
  },
  information: {
    fontSize: '16px',
    fontWeight: 300
  },
  linearProgress: {
    width: '80%',
    margin: '20px 0'
  }
});
